// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ContainerComponent } from './container/container.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    ContainerComponent,
  ],
  exports: [
    ContainerComponent,
  ],
})
export class ContainerModule {
}
